import { createHTTPClient } from "@airhelp/http-client";
import { caller, valid, snakeCaseBody } from "@airhelp/http-client/addons";
import { i, P, j, S, h, c, b, g, d, e, a, f, l, o } from "./fetch-lounges-DBfdg699.js";
function createBaseAhPlusHTTPClient({
  caller: caller$1,
  baseURL,
  options
}) {
  return createHTTPClient({
    baseURL,
    options: {
      credentials: "include",
      ...options
    }
  }).addon(caller).addon(valid()).addon(snakeCaseBody()).caller(caller$1);
}
export {
  i as PAYMENT_FREQUENCY,
  P as PRODUCT_NAME,
  j as PRODUCT_PERK,
  S as SUPPORTED_CURRENCY_CODES,
  createBaseAhPlusHTTPClient,
  h as featureFlagSchema,
  c as fetchFeatureFlags,
  b as fetchFeatureFlagsResponseSchema,
  g as fetchLounges,
  d as fetchLoungesRequestSchema,
  e as fetchLoungesResponseSchema,
  a as fetchOffers,
  f as fetchOffersResponseSchema,
  l as loungeSchema,
  o as offerSchema
};
//# sourceMappingURL=index.js.map
